import axios from "axios";
import axiosRetry from "axios-retry";

const axiosWrapper = () => {
  const baseURL = process.env.REACT_APP_BACKEND_ADDRESS || "http://localhost:8000";
  const token = localStorage.getItem("token");

  // Detect current language from i18next or browser
  const lang = localStorage.getItem("i18nextLng") || navigator.language || "es";

  const headers = {
    "Content-Type": "application/json",
    "Accept-Language": lang,
  };

  // Add authorization token if available
  if (token) {
    headers["Authorization"] = `Token ${token}`;
  }

  const client = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    headers: headers,
  });

  // Remove Content-Type for FormData so axios sets multipart/form-data with boundary
  client.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  });

  // Interceptor to handle 401 errors (invalid/expired token)
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Token is invalid or expired - clear it
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("groups");
        // Redirect to frontend home
        window.location.href = (process.env.PUBLIC_URL || "") + "/";
      }
      return Promise.reject(error);
    }
  );

  axiosRetry(client, {
    retries: 3,
    retryDelay: () => 3000,
    retryCondition: (error) => {
      const status = error.response ? error.response.status : null;
      const retryStatusCodes = [499, 530, 598, 599, 502, 503, 504, 505, 506, 507, 440];
      const retryStatus = retryStatusCodes.includes(status) || error.code === "ECONNABORTED";

      return retryStatus;
    },
  });

  return client;
};

export default axiosWrapper;
